<module-container>
  <div class="title-container">
    <h2>Global Supplier Store Map</h2>
  </div>
  <abcis-table [configuration]="tableConfig"></abcis-table>
</module-container>
